import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

import { isActiveInsider } from "../visibilityFunctions/shared-utils";

import { GoToMembershipSettingsCTA, InsiderBenefitsLearnMoreCTA } from "./ctas";

export const BenefitsIA: InstantAnswerBuilderFn = (strictLocalize) => {
  return {
    titleBuilder: (context) => {
      return getAnswer(context, strictLocalize).getTitle();
    },

    descriptionBuilder: (context) => {
      return getAnswer(context, strictLocalize).getDescription();
    },

    primaryCtaBuilder: {
      textBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.label;
      },
      linkBuilder: (context) => {
        return getPrimaryCTA(context, strictLocalize)?.getLink?.(
          context.brandOrder
        );
      },
    },
  };
};

const getAnswer = (
  _context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario =>
  isActiveInsider()
    ? INSIDER_RETAILER(strictLocalize)
    : NON_INSIDER_RETAILER(strictLocalize);

const getPrimaryCTA: CtaBuilderFn = (_context, strictLocalize) =>
  isActiveInsider()
    ? GoToMembershipSettingsCTA(strictLocalize)
    : InsiderBenefitsLearnMoreCTA(strictLocalize);

const INSIDER_RETAILER = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => INSIDER_MEMBERSHIP_BENEFITS(strictLocalize),
  getDescription: () => [WITH_YOUR_INSIDER_MEMBERSHIP(strictLocalize)],
});

const NON_INSIDER_RETAILER = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => ({
  getTitle: () => INSIDER_MEMBERSHIP_BENEFITS(strictLocalize),
  getDescription: () => [WHEN_YOU_SIGN_UP_FOR_INSIDER(strictLocalize)],
});

const INSIDER_MEMBERSHIP_BENEFITS = (strictLocalize: StrictLocalizeFunction) =>
  getSettingSelfServeRetailerTaxonomy()
    ? strictLocalize({
        defaultMessage: "About Insider membership",
        description: {
          text: "Title for the instant answer of insider membership benefits issue",
        },
      })
    : strictLocalize({
        defaultMessage: "Insider membership benefits",
        description: {
          text: "Title for the instant answer of insider membership benefits issue",
        },
      });

const WITH_YOUR_INSIDER_MEMBERSHIP = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "With your Insider membership, you gain access to free shipping from thousands of Faire-selected brands. Additionally, you get exclusive early access to Faire’s virtual trade shows and the latest brand arrivals on our site. To review your Insider membership details, simply click the button below and visit the “Insider Membership” tab within your Account settings.",
  });

const WHEN_YOU_SIGN_UP_FOR_INSIDER = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage:
      "When you sign up for an Insider membership, you gain access to free shipping from thousands of Faire-selected brands. Additionally, you will enjoy exclusive early access to Faire’s virtual trade shows and newly arrived brands on the site. To access these benefits, simply sign up for a 30-day free trial. After the trial period ends, you will be charged monthly to the payment method you select.",
  });
